import { useDispatch } from 'react-redux'
import React, { useState } from 'react'
import * as rest from '../../../services'
import { showErrorToast, showSuccessToast } from '../../../state/toasts'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../../components'

export const SendInwardBySMS = ({ ticket }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const send = () => {
    setLoading(true)
    new rest.TicketService(ticket.url)
      .send_ticket_details_by_sms()
      .then(() => {
        setLoading(false)
        dispatch(showSuccessToast('Sent Ticket Details By SMS'))
      })
      .catch((error) => {
        setLoading(false)
        dispatch(showErrorToast('Could not Send Ticket Details By SMS'))
      })
  }
  return (
    <ReactBootstrap.Dropdown.Item  size={"sm"} onClick={() => send()}>
      {loading ? <components.Loading /> : '  Send Inward Details By SMS'}
    </ReactBootstrap.Dropdown.Item>
  )
}
